export function hasKeyValuePair(obj, key, value) {
  return key in obj && obj[key] == value;
}
